import BaseService from "./BaseService";

export default class ApplyFormService extends BaseService {
  static endPoint = "form";
}
